/* =========================================================
   AMĀRA THEME — core interactions
   ========================================================= */
(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR';

  function formatMoney(cents) {
    try {
      var amount = (cents / 100).toFixed(2);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR',
        minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '₹' + (cents / 100).toFixed(2);
    }
  }
  window.themeFormatMoney = formatMoney;

  /* ---------- Toasts ---------- */
  function showToast(message, isError) {
    var container = document.getElementById('ToastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'toast' + (isError ? ' toast--error' : '');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 250);
    }, 2600);
  }
  window.themeShowToast = showToast;

  /* ---------- Focus trap helper ---------- */
  function trapFocus(container) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    first.focus();
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- Generic openable panel (drawer / modal / overlay) ---------- */
  function openPanel(el, triggerEl) {
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
    el.dataset.releaseFocus = '1';
    trapFocus(el);
  }
  function closePanel(el, triggerEl) {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    el.hidden = true;
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
  }
  window.themeOpenPanel = openPanel;
  window.themeClosePanel = closePanel;

  /* ---------- Mobile drawer menu ---------- */
  var drawer = document.getElementById('MobileDrawer');
  var drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
  var drawerCloseEls = document.querySelectorAll('[data-drawer-close]');
  drawerOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { if (drawer) openPanel(drawer, btn); });
  });
  drawerCloseEls.forEach(function (el) {
    el.addEventListener('click', function () { if (drawer) closePanel(drawer, drawerOpenBtns[0]); });
  });

  /* Drawer accordions (submenus) */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var panel = toggle.nextElementSibling;
      var isOpen = panel.classList.contains('is-open');
      panel.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- Search overlay ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchOpenBtns = document.querySelectorAll('[data-search-open]');
  var searchCloseBtns = document.querySelectorAll('[data-search-close]');
  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchOverlay) return;
      searchOverlay.hidden = false;
      searchOverlay.setAttribute('aria-hidden', 'false');
      var input = searchOverlay.querySelector('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    });
  });
  searchCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchOverlay) return;
      searchOverlay.hidden = true;
      searchOverlay.setAttribute('aria-hidden', 'true');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchOverlay && !searchOverlay.hidden) { searchOverlay.hidden = true; }
      if (drawer && !drawer.hidden) closePanel(drawer, drawerOpenBtns[0]);
      var cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer && !cartDrawer.hidden) closePanel(cartDrawer);
      var quickAdd = document.getElementById('QuickAddModal');
      if (quickAdd && !quickAdd.hidden) closePanel(quickAdd);
      var filterPanel = document.querySelector('[data-filter-panel]');
      if (filterPanel && !filterPanel.hidden) filterPanel.hidden = true;
    }
  });

  /* Predictive search (lightweight) */
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  if (searchInput && searchResults) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="empty-state">No quick matches — press enter to search all results.</p>';
              return;
            }
            searchResults.innerHTML = '<div class="product-grid product-grid--2-4">' + products.map(function (p) {
              return '<a class="product-card" href="' + p.url + '">' +
                '<div class="product-card__media-wrap"><img class="product-card__image product-card__image--primary" src="' + (p.featured_image ? p.featured_image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_400x$1$2') : '') + '" alt="' + p.title + '" loading="lazy"></div>' +
                '<div class="product-card__info"><h3 class="product-card__title">' + p.title + '</h3><div class="price"><span class="price__regular">' + p.price + '</span></div></div>' +
                '</a>';
            }).join('') + '</div>';
          })
          .catch(function () {});
      }, 280);
    });
  }

  /* ---------- Announcement bar rotation ---------- */
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar && announcementBar.dataset.autoplay) {
    var items = announcementBar.querySelectorAll('.announcement-bar__item');
    if (items.length > 1) {
      var current = 0;
      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, parseInt(announcementBar.dataset.autoplay, 10) * 1000);
    }
  }

  /* ---------- Copy coupon code ---------- */
  document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.dataset.code;
      var label = btn.querySelector('[data-copy-label]');
      navigator.clipboard.writeText(code).then(function () {
        if (label) { var original = label.textContent; label.textContent = 'Copied!'; setTimeout(function () { label.textContent = original; }, 2000); }
        showToast('Coupon copied!');
      }).catch(function () { showToast('Could not copy code', true); });
    });
  });

  /* ---------- Generic accordions (product info, footer) ---------- */
  document.querySelectorAll('.accordion__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var panel = toggle.nextElementSibling;
      var isOpen = panel.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.classList.toggle('is-open', !isOpen);
    });
  });
  document.querySelectorAll('.footer-accordion__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      if (window.innerWidth >= 768) return;
      var panel = toggle.nextElementSibling;
      panel.classList.toggle('is-open');
    });
  });

  /* ---------- Collection filter drawer ---------- */
  var filterOpenBtn = document.querySelector('[data-filter-open]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  var filterCloseBtn = document.querySelector('[data-filter-close]');
  if (filterOpenBtn && filterPanel) {
    filterOpenBtn.addEventListener('click', function () { filterPanel.hidden = false; document.body.style.overflow = 'hidden'; });
  }
  if (filterCloseBtn && filterPanel) {
    filterCloseBtn.addEventListener('click', function () { filterPanel.hidden = true; document.body.style.overflow = ''; });
  }
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Quick add modal ---------- */
  var quickAddModal = document.getElementById('QuickAddModal');
  var quickAddContent = document.getElementById('QuickAddModalContent');

  function buildQuickAddContent(product) {
    var variant = product.variants[0];
    var optionsHtml = '';
    if (product.variants.length > 1) {
      product.options.forEach(function (optionName, index) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (index + 1)];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="product-form__option" data-qa-option-index="' + index + '">' +
          '<label class="product-form__option-label">' + optionName + '</label>' +
          '<select class="product-form__select" data-qa-option-select data-index="' + index + '">' +
          values.map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('') +
          '</select></div>';
      });
    }
    var image = product.images && product.images[0] ? product.images[0] : '';
    return '<img src="' + image + '" alt="' + product.title + '" width="180" height="180">' +
      '<div>' +
      '<h3>' + product.title + '</h3>' +
      '<div class="price" data-qa-price><span class="price__regular">' + formatMoney(variant.price) + '</span></div>' +
      optionsHtml +
      '<div class="product-form__quantity"><div class="quantity-selector">' +
      '<button type="button" class="quantity-selector__button" data-qa-qty-decrease>−</button>' +
      '<input type="number" class="quantity-selector__input" value="1" min="1" data-qa-qty-input>' +
      '<button type="button" class="quantity-selector__button" data-qa-qty-increase>+</button>' +
      '</div></div>' +
      '<button type="button" class="btn btn--primary" style="width:100%;margin-top:1rem;" data-qa-add data-variant-id="' + variant.id + '">Add to bag</button>' +
      '</div>';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add-trigger]');
    if (!trigger || !quickAddModal) return;
    var handle = trigger.dataset.productHandle;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        quickAddContent.innerHTML = buildQuickAddContent(product);
        quickAddContent.dataset.variants = JSON.stringify(product.variants);
        openPanel(quickAddModal, trigger);
      })
      .catch(function () { showToast('Could not load product', true); });
  });

  document.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
    el.addEventListener('click', function () { closePanel(quickAddModal); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qa-qty-increase]')) {
      var input = quickAddContent.querySelector('[data-qa-qty-input]');
      input.value = Math.max(1, parseInt(input.value || 1, 10) + 1);
    }
    if (e.target.closest('[data-qa-qty-decrease]')) {
      var input2 = quickAddContent.querySelector('[data-qa-qty-input]');
      input2.value = Math.max(1, parseInt(input2.value || 1, 10) - 1);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qa-option-select]') && quickAddContent) {
      var variants = JSON.parse(quickAddContent.dataset.variants || '[]');
      var selects = quickAddContent.querySelectorAll('[data-qa-option-select]');
      var selected = Array.from(selects).map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v['option' + (i + 1)] === val; });
      });
      if (match) {
        var addBtn = quickAddContent.querySelector('[data-qa-add]');
        if (addBtn) addBtn.dataset.variantId = match.id;
        var priceEl = quickAddContent.querySelector('[data-qa-price]');
        if (priceEl) priceEl.innerHTML = '<span class="price__regular">' + formatMoney(match.price) + '</span>';
      }
    }
  });

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-qa-add]');
    if (!addBtn) return;
    var qtyInput = quickAddContent.querySelector('[data-qa-qty-input]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    addBtn.disabled = true;
    if (window.themeAddToCart) {
      window.themeAddToCart(addBtn.dataset.variantId, qty).then(function () {
        closePanel(quickAddModal);
        showToast('Added to your bag');
      }).catch(function () {
        showToast('Could not add this item', true);
      }).finally(function () { addBtn.disabled = false; });
    }
  });

  /* ---------- Recently viewed (localStorage) ---------- */
  var RECENT_KEY = 'amara_recently_viewed';
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function pushRecent(handle) {
    var list = getRecent().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 12);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  }
  var recentlyViewedEl = document.querySelector('[data-recently-viewed]');
  if (recentlyViewedEl) {
    var currentHandle = recentlyViewedEl.dataset.currentHandle;
    if (currentHandle) pushRecent(currentHandle);
    var list = getRecent().filter(function (h) { return h !== currentHandle; }).slice(0, 5);
    var grid = recentlyViewedEl.querySelector('[data-recently-viewed-grid]');
    if (list.length && grid) {
      Promise.all(list.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<div class="product-card"><a href="' + p.url + '" class="product-card__media-wrap"><img class="product-card__image product-card__image--primary" src="' + img + '" alt="' + p.title + '" loading="lazy"></a>' +
            '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
            '<div class="price"><span class="price__regular">' + formatMoney(p.price) + '</span></div></div></div>';
        }).join('');
        recentlyViewedEl.hidden = false;
      });
    }
  }

  /* ---------- Product recommendations (native Shopify endpoint) ---------- */
  var recEl = document.querySelector('[data-product-recommendations]');
  if (recEl && recEl.dataset.url) {
    fetch(recEl.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newGrid = temp.querySelector('[data-product-recommendations-grid]');
        var currentGrid = recEl.querySelector('[data-product-recommendations-grid]');
        if (newGrid && currentGrid && newGrid.children.length) {
          currentGrid.innerHTML = newGrid.innerHTML;
        } else if (!newGrid || !newGrid.children.length) {
          recEl.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  /* ---------- Header shadow on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      lastY = y;
    }, { passive: true });
  }
})();
